import { updatePrimaryDiagnosisCode } from "../../../../api/postCall/updatePrimaryDiagnosisCode";
import { TableData } from "../ClinicalDataTable";

export const dropdownOptions = (tableData: TableData[]) =>
  tableData.map((entry) => ({
    value: entry.icd10_code || "",
    label: `${entry.icd10_code || ""} - ${entry.icd10_desc || ""}`,
  }));

interface HandleSaveOptions {
  onSave?: () => void;
  onStart?: () => void;
  onFinish?: () => void;
  onError?: (error: any) => void;
}

export const handleSave = async (
  selectedPrimaryCode: string,
  tableData: TableData[],
  orderId?: string,
  options?: HandleSaveOptions,
) => {
  if (!orderId || !selectedPrimaryCode) return;

  const selectedEntry = tableData.find(
    (entry) => entry.icd10_code === selectedPrimaryCode,
  );
  if (!selectedEntry) return;

  options?.onStart?.();

  try {
    await updatePrimaryDiagnosisCode(
      orderId,
      selectedEntry.icd10_code || "",
      selectedEntry.icd10_desc || "",
      true,
    );

    options?.onSave?.();
  } catch (error) {
    console.error("Error saving primary diagnosis:", error);
    options?.onError?.(error);
  } finally {
    options?.onFinish?.();
  }
};
